import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserInstituteMappingPage } from '@/features/userInstituteMapping/pages/UserInstituteMappingPage';

export const userInstituteMappingSearchSchema = z.object({
  tab: z.enum(['current', 'assign']).optional(),
  userId: z.coerce.number().int().positive().optional(),
  instituteTypeId: z.coerce.number().int().positive().optional(),
  divisionId: z.coerce.number().int().positive().optional(),
  districtId: z.coerce.number().int().positive().optional(),
  thanaId: z.coerce.number().int().positive().optional(),
  instituteId: z.coerce.number().int().positive().optional(),
  eiinNumber: z.string().optional(),
  name: z.string().optional(),
});

export type UserInstituteMappingSearch = z.infer<typeof userInstituteMappingSearchSchema>;

export const Route = createFileRoute('/_auth/settings/institutes/user-mapping')({
  beforeLoad: () => {
    requireOfficeAccess();
    requirePermission(RBAC_PERMISSIONS.INSTITUTE_MAPPING_VIEW);
  },
  validateSearch: userInstituteMappingSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Institute With User Mapping">
      <Suspense fallback={<PageLoader />}>
        <UserInstituteMappingPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
